// state
export const state = {
  queue: [],
};

// getters
export const getters = {
  getSnackbars: (state) => state.queue,
  getSnackbarToDisplay: (state) => (state.queue.length > 0 ? state.queue[0] : undefined),
};

// mutations
export const mutations = {
  /**
   * Add a snackbar
   * @param state
   * @param s
   */
  addSnackbar(state, s) {
    // Default snackbar options
    const newSnackbar = {
      id: 'default_snackbar',
      color: undefined,
      icon: 'close',
      timeout: 30000,
      content: 'content',
      progressBar: true,
      ...s,
    };
    if (newSnackbar.timeout > 30000) {
      newSnackbar.timeout = 30000;
    }

    // Checking either the snackbar already exists or not
    // eslint-disable-next-line no-shadow
    const foundSnackbar = state.queue.find((s) => s.id === newSnackbar.id);
    if (foundSnackbar) {
      foundSnackbar.color = newSnackbar.color;
      foundSnackbar.content = newSnackbar.content;
    } else state.queue.push(newSnackbar);
  },
  /**
   * Delete a snackbar
   * @param state
   * @param snackbarId
   */
  deleteSnackbar(state, snackbarId) {
    const clonedSnackbars = JSON.parse(JSON.stringify(state.queue));
    const foundSnackbarIndex = clonedSnackbars.findIndex((snackbar) => snackbar.id === snackbarId);
    if (foundSnackbarIndex >= 0) {
      clonedSnackbars.splice(foundSnackbarIndex, 1);
      state.queue = clonedSnackbars;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
